import { defineComponent, h } from 'vue';

import { CdsTextInput } from '../../../CdsTextInput';

import type { NTable } from '@components/components/CdsTable/interface';

interface IFilterSearchProps {
  value: string;
  filterSearch: NTable.TFilterSearch;
  locale: NTable.ILocale;
  onChange: (event: InputEvent) => void;
}

export default defineComponent<IFilterSearchProps>({
  name: 'FilterSearch',
  inheritAttrs: false,
  props: ['value', 'filterSearch', 'locale'] as any,
  setup(props) {
    return () => {
      const { value, onChange, filterSearch, locale } = props;

      if (!filterSearch) return null;

      return h(
        'div',
        { class: 'cds-table__filter-dropdown-search' },
        h(CdsTextInput, {
          value,
          size: 'sm',
          placeholder: locale.filterSearchPlaceholder,
          prependInnerIcon: 'search',
          hideMessages: true,
          class: 'cds-table__filter-dropdown-search-input',
          onChange
        })
      );
    };
  }
});
